import React, { createContext, useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import Home from "./Pages/Home";
import Aboutus from "./Pages/Aboutus";
import Activities from "./Pages/Activities";
import Contactus from "./Pages/Contactus";
import Academics from "./Pages/Academics";
import Approvalpage from "./Pages/Approvalpage";
import NewsPage from "./Pages/NewsPage";
import LoginPage from "./Pages/LoginPage";
import AddCollegesPage from "./Pages/AddCollegesPage";
import AddBannerImagesPage from "./Pages/AddBannerImagesPage";
import AddFacultiesPage from "./Pages/AddFacultiesPage";
import AddRecruitersPage from "./Pages/AddRecruitersPage";
import AddEventsPage from "./Pages/AddEventsPage";
import EventDetailPage from "./Pages/EventDetailPage";
import AddClubsPage from "./Pages/AddClubsPage";
import ClubDetailPage from "./Pages/ClubDetailPage";
import AddNewsPage from "./Pages/AddNewsPage";
import AddTestimonialsPage from "./Pages/AddTestimonialsPage";
import AddAlumniPage from "./Pages/AddAlumniPage";
import AddDirectorMessagePage from "./Pages/AddDirectorMessagePage";
import UserStudentClubs from "./Pages/UserStudentClubs";
import UserDocuments from "./Pages/UserDocuments";
import AddDocumentsPage from "./Pages/AddDocumentsPage";
import EnquiryPage from "./Pages/AllEnquiryPage";
import AddStudentAchievements from "./Pages/AddStudentAchievements";
import UserStudentAchievements from "./Pages/UserStudentAchievements";
import UserStudentTestimonials from "./Pages/UserStudentTestimonials";
import UserOurAlumni from "./Pages/UserOurAlumni";
import NotFound from "./Pages/PageNotFound";
import PrivateRoute from "./Pages/PrivateRoute";
import Navbar from "./components/Navbar";
import { useDispatch, useSelector } from "react-redux";
import { fetchAllColleges } from "./Slices/CollegeSlice.jsx"
import { fetchAllDocuments } from "./Slices/DocumentSlice.jsx";
import { fetchAllMarquees } from "./Slices/MarqueeSlice.jsx";
import { fetchAllCoursesWithColleges } from "./Slices/CourseSlice.jsx";
import { fetchAllEvents } from "./Slices/EventSlice.jsx";
import { fetchAllRecruiters } from "./Slices/RecruiterSlice.jsx";
import { fetchNews } from "./Slices/NewsSlice.jsx";
import { fetchAllClubs } from "./Slices/ClubSlice.jsx";
import UniversityCareers from "./Pages/UniversityCareers.jsx";
import { hideLoader, showLoader } from "./Slices/LoaderSlice.jsx";
export const CourseWiseStepsContext = createContext();
export const InquiryContext = createContext();
export const SideBarOpenTab = createContext();

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

function AppContent() {
  const location = useLocation();
  const [openInquiryModel, setOpenInquiryModel] = useState(false);
  const [openTab, setOpenTab] = useState(null);
  const dispatch = useDispatch();
  useEffect(() => {
    const runLoader = async () => {
      dispatch(showLoader());
      await new Promise((resolve) => setTimeout(resolve, 800));
      dispatch(hideLoader());
    };
    runLoader();
  }, [dispatch]);
  const { isLoading: loadingfromloader } = useSelector((state) => state.loader);
  const { loading: collegesLoading } = useSelector((state) => state.colleges);
  const isLoading = collegesLoading || loadingfromloader;

  const [step, setStep] = useState([
    { name: "Director Message", Director_Message: false },
    { name: "Overview", overview: true },
    { name: "Course Structure", Course_Structure_and_Duration: false },
    { name: "Eligibility", eligibility: false },
    { name: "Syllabus", syllabus: false },
    { name: "Fees Structure", feesStructure: false },
    { name: "Faculty", Faculty: false },
    { name: "Academic Calendar", Academic_Calendar: false },
    { name: "News", news: false },
    { name: "Events", events: false },
    { name: "Enquiry Form", Inquiry: false },
  ]);

  const showNavbarRoutes = [
    "/", "/about", "/activities", "/contact", "/news",
    "/StudentClubs", "/StudentTestimonials", "/StudentAchievements", "/OurAlumni", "/activities/", "/contact/", "/about/"
  ];

  const shouldShowNavbar =
    showNavbarRoutes.includes(location.pathname) ||
    location.pathname.startsWith("/academics/");
  // useEffect(() => {
  //   dispatch(fetchAllColleges());
  //   dispatch(fetchAllDocuments());
  //   dispatch(fetchAllMarquees());
  //   dispatch(fetchAllEvents());
  //   dispatch(fetchAllRecruiters());
  //   dispatch(fetchNews());
  //   dispatch(fetchAllClubs());
  // }, [dispatch]);
  // useEffect(() => {
  //   dispatch(
  //     fetchAllCoursesWithColleges({ allColleges })
  //   );
  // }, [allColleges, dispatch])

  return (
    <SideBarOpenTab.Provider value={{ openTab, setOpenTab }}>
      <InquiryContext.Provider value={{ openInquiryModel, setOpenInquiryModel }}>
        <CourseWiseStepsContext.Provider value={{ step, setStep }}>
          {shouldShowNavbar && !isLoading && <Navbar />}
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/*" element={<NotFound />} />
            {/* <Route path="/AddColleges" element={<PrivateRoute><AddCollegesPage /></PrivateRoute>} />
            <Route path="/AddBannerImages" element={<PrivateRoute><AddBannerImagesPage /></PrivateRoute>} />
            <Route path="/AddStaff" element={<PrivateRoute><AddFacultiesPage /></PrivateRoute>} />
            <Route path="/AddDirectorMessage" element={<PrivateRoute><AddDirectorMessagePage /></PrivateRoute>} />
            <Route path="/AddReuiters" element={<PrivateRoute><AddRecruitersPage /></PrivateRoute>} />
            <Route path="/AddEvents" element={<PrivateRoute><AddEventsPage /></PrivateRoute>} />
            <Route path="/AddClubs" element={<PrivateRoute><AddClubsPage /></PrivateRoute>} />
            <Route path="/AddNews" element={<PrivateRoute><AddNewsPage /></PrivateRoute>} />
            <Route path="/AddTestimonials" element={<PrivateRoute><AddTestimonialsPage /></PrivateRoute>} />
            <Route path="/AddAlumni" element={<PrivateRoute><AddAlumniPage /></PrivateRoute>} />
            <Route path="/Enquiries" element={<PrivateRoute><EnquiryPage /></PrivateRoute>} />
            <Route path="/AddAchievements" element={<PrivateRoute><AddStudentAchievements /></PrivateRoute>} />
            <Route path="/AddEvents/events/:event_id" element={<PrivateRoute><EventDetailPage /></PrivateRoute>} />
            <Route path="/AddClubs/clubs/:club_id" element={<PrivateRoute><ClubDetailPage /></PrivateRoute>} />
            <Route path="/AddDocumentsPage" element={<PrivateRoute><AddDocumentsPage /></PrivateRoute>} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/about" element={<Aboutus />} />
            <Route path="/activities" element={<Activities />} />
            <Route path="/contact" element={<Contactus />} />
            <Route path="/academics/:college_id/:course/:course_id" element={<Academics />} />
            <Route path="/academics/:college_id/:course/:course_id/:name/:id" element={<Academics />} /> */}
            {/* <Route path="/approval" element={<Approvalpage />} /> */}
            {/* <Route path="/news" element={<NewsPage />} /> */}
            {/* <Route path="/StudentClubs" element={<UserStudentClubs />} /> */}
            {/* <Route path="/StudentTestimonials" element={<UserStudentTestimonials />} /> */}
            {/* <Route path="/StudentAchievements" element={<UserStudentAchievements />} /> */}
            {/* <Route path="/OurAlumni" element={<UserOurAlumni />} /> */}
            {/* <Route path="/Documents/:document_name/:document_id" element={<UserDocuments />} /> */}
            {/* <Route path="/Jobs" element={<UniversityCareers />} /> */}
          </Routes>
        </CourseWiseStepsContext.Provider>
      </InquiryContext.Provider>
    </SideBarOpenTab.Provider>
  );
}

export default App;
